import React from 'react'
import AccessibilityWidget from 'components/organisms/AccessibilityWidget'
import useInitialProps from '../../hooks/useStaticContext'

const AccessibilityPage = ({ staticContext }) => {
  const { handicaps, pictureUrl, cardUrl, orientation } =
    useInitialProps(staticContext)

  return (
    <AccessibilityWidget
      handicaps={handicaps}
      pictureUrl={pictureUrl}
      cardUrl={cardUrl}
      orientation={orientation}
    />
  )
}

export default AccessibilityPage
